import {useState} from 'react';
import {useSearchParams} from 'react-router-dom';
import {sha256} from 'js-sha256';
import {Alert, Box, Tab, Tabs, Typography} from '@mui/material';
import {setUserToken} from '../../../utils/api';
import Dashboard1 from './Dashboard1';
import Dashboard2 from './Dashboard2';
import Dashboard3 from './Dashboard3';
import Dashboard4 from './Dashboard4';

const TABS = [
    {label: 'Dashboard 1', subtitle: 'Promozione della cultura del dono'},
    {label: 'Dashboard 2', subtitle: 'Erogazione agli enti del territorio'},
    {label: 'Dashboard 3', subtitle: 'Capacitazione degli enti del territorio'},
    {label: 'Dashboard 4', subtitle: 'Attivazione della comunità e sviluppo di reti'},
];

const DashboardIndex = () => {
    const [searchParams] = useSearchParams();
    const [activeTab, setActiveTab] = useState(0);

    const container = searchParams.get('container_id');
    const uoaId = searchParams.get('uoa_id');
    const surveyId = searchParams.get('survey_id');
    const surveyEvalId = searchParams.get('survey_eval_id');
    const surveyPublicId = searchParams.get('survey_public_id');
    const hashKey = searchParams.get('key');
    const token = searchParams.get('token');

    const hashKeyLocal = sha256(process.env.REACT_APP_HASH_KEY_FDC || '');

    if (token) {
        setUserToken(token);
    }

    const isAuthorized = !!(container && uoaId && surveyId && surveyEvalId && surveyPublicId && hashKey === hashKeyLocal);

    if (!isAuthorized) {
        return <Alert severity='error'>Parametri mancanti o chiave non valida.</Alert>;
    }

    return (
        <Box>
            <Box sx={{borderBottom: 1, borderColor: 'divider', mb: 3}}>
                <Tabs value={activeTab} onChange={(_, value) => setActiveTab(value)} variant='scrollable' scrollButtons='auto'>
                    {TABS.map((tab, i) => (
                        <Tab
                            key={i}
                            label={
                                <Box sx={{textAlign: 'left'}}>
                                    <Typography variant='body2' fontWeight={500}>
                                        {tab.label}
                                    </Typography>
                                    <Typography variant='caption' color='text.disabled'>
                                        {tab.subtitle}
                                    </Typography>
                                </Box>
                            }
                        />
                    ))}
                </Tabs>
            </Box>

            <Box role='tabpanel' hidden={activeTab !== 0}>
                {activeTab === 0 && <Dashboard1 container={container!} uoaId={uoaId!} surveyId={surveyId!} surveyEvalId={surveyEvalId!} />}
            </Box>

            <Box role='tabpanel' hidden={activeTab !== 1}>
                {activeTab === 1 && <Dashboard2 container={container!} uoaId={uoaId!} surveyId={surveyId!} surveyEvalId={surveyEvalId!} />}
            </Box>

            <Box role='tabpanel' hidden={activeTab !== 2}>
                {activeTab === 2 && (
                    <Dashboard3 container={container!} uoaId={uoaId!} surveyId={surveyId!} surveyEvalId={surveyEvalId!} surveyPublicId={surveyPublicId!} />
                )}
            </Box>

            <Box role='tabpanel' hidden={activeTab !== 3}>
                {activeTab === 3 && <Dashboard4 container={container!} uoaId={uoaId!} surveyId={surveyId!} surveyPublicId={surveyPublicId!} />}
            </Box>
        </Box>
    );
};

export default DashboardIndex;
